/**
 * A2 No86_2: 一部助成 label suffix derived from special_calculation_cost (calc_type +
 * limit_*). Shared by MedicalAidSection (current selection display) and
 * MedicalAidSearchModal (補助入力 dropdown row label).
 */
export function formatSpecialCalculation(
  calcType: number | null | undefined,
  limitAmount: number | null | undefined,
  limitNumMonth: number | null | undefined,
  limitAmountMonth: number | null | undefined
): string {
  if (calcType == null) return '';
  const nf = (v: number | null | undefined) => (v ?? 0).toLocaleString('en-US');
  if (calcType === 1) return `1回${nf(limitAmount)}円　月${limitNumMonth ?? 0}回まで`;
  if (calcType === 2) return `1ヵ月上限（限度額）${nf(limitAmountMonth)}円`;
  if (calcType === 3) {
    return `1回${nf(limitAmount)}円　までで 1ヵ月上限（限度額）${nf(limitAmountMonth)}円`;
  }
  return '';
}
